export default "__VITE_ASSET__CJwQg0sI__"